// services/adsService.ts
import http from '@/utils/http' // Assuming you have a configured http client
import { Advertisement } from '@/models/ads.model'
import { NewsResponse } from '@/models/news.model'
export interface AsdPostResponse {
  id: string
  title: string
  content: string
  imageUrl?: string // 🔹 Đảm bảo có `?` để tránh undefined
  extraImages?: string[] // 🔹 Đảm bảo không bị undefined
  categoryId: string
  categoryName: string
  publishDate: string
  createdAt: string
  createdBy: string
  slug: string
  facebook: string
  phoneNumber: string
  contactName: string
  websiteUrl: string
  address: string
  email: string
  metaKeyword: string
  description: string
}
/**
 * Fetch danh sách quảng cáo
 */
export const fetchAds = async (): Promise<Advertisement[]> => {
  const response = await http.get<Advertisement[]>('/advertisements')
  return response
}
export const fetchClassifieds = async (
  page: number,
  size: number,
  slug: string,
  categorySlug: string
): Promise<NewsResponse> => {
  const response = await http.get<NewsResponse>('rao-vat', {
    params: {
      page,
      size,
      slug,
      categorySlug,
    },
  })
  return response
}
export const fetchPost = async (slug: string = ''): Promise<AsdPostResponse> => {
  const response = await http.get<AsdPostResponse>(`/rao-vat/${slug}`)
  return response
}
